// TODO close modal when storybook navigates to another page
// TODO required properties
// TODO define getters and setters and also events availabe to read by devs
// TODO strip html from header text
// TODO focus() function
// TODO stop body scroll
// TODO aria attributes and roles
// TODO check lets and consts
// TODO help button functionality
// TODO popout button functionality
// TODO variant styles that change header and footer bar colours
// TODO Animation styles

// TODO allow multiple classNames?
// TODO 'status' rhs header thingy? I saw this somewhere in the app...
// TODO define templates elsewhere instead of building divs in buildModal()
// TODO custom header function icons (in addition to close, popout and help)
// TODO Indexing for multiple modals?
// TODO other keyboard events?

// TODO provided template version
// TODO data attr instantiation?
// TODO combo data-attr and js instantiation, so still need to init()
// Check document for data ax modal
// Build object from Data attributes for each option
// Run constructor on it

export type ModalUIEvent =
    | ((event: Event, modal: AxModal) => void)
    | null
    | undefined;
export type ComponentType = 'modal' | 'dialog';
export type BodyContentType = null | undefined | 'normal' | 'iframe';
export interface IBodyContentIFrame {
    iframeId?: string;
    url: string;
    height: string;
}

export interface IIconButton {
    isVisible: boolean;
    onClick: ModalUIEvent;
}

export interface IFooterButton {
    text: string;
    type: 'primary' | 'secondary' | 'tertiary' | 'link' | 'cautionary';
    position: 'left' | 'right';
    onClick: ModalUIEvent;
}

export interface IAxModalOptions {
    animationStyle: string;
    bodyContent: string | HTMLElement;
    bodyContentType?: BodyContentType; // default to 'normal'
    bodyContentIframe?: IBodyContentIFrame;
    className: string;
    clickOutsideToClose: boolean;
    closeIconButton: boolean;
    footerButtons: IFooterButton[];
    helpIconButton?: IIconButton; // only used for modals
    id: string;
    lazyBuild: boolean;
    overlay: boolean;
    popoutIconButton?: IIconButton; // only used for modals
    size?: 'normal' | 'window'; // only used for modals
    title: string | HTMLElement;
    zIndex: number;
}

export const openUrlInWindow = (
    url: string,
    target: string = '_blank',
    width: number = 605,
    height: number = 300,
    dismissModal: boolean = true
) => (event: Event, modal: AxModal) => {
    window.open(url, target, `width=${width}, height=${height}`);

    if (dismissModal && modal) {
        modal.hide();
        modal.destroy();
    }
};

export default class AxModal {
    public static openUrlInWindow = openUrlInWindow;
    private isBuilt: boolean = false;
    private modal: HTMLDivElement;
    private overlay: any;
    private componentType: ComponentType = 'modal';
    private options: IAxModalOptions = {
        animationStyle: '',
        bodyContent: '', // String or HTML
        bodyContentType: 'normal', // String
        bodyContentIframe: {
            iframeId: '',
            url: '',
            height: '',
        },
        className: '',
        clickOutsideToClose: false,
        closeIconButton: true, // On by default
        helpIconButton: {
            isVisible: false,
            onClick: null,
        }, // hidden by default
        footerButtons: [
            // Array of objects
            {
                text: 'Close',
                type: 'tertiary', // Primary, secondary, tertiary, link, cautionary
                position: 'left', // Right or left
                onClick: null, // pass in a function
            },
        ],
        id: '',
        lazyBuild: false, // Build the modal either at instantiation or on show()
        overlay: true, // The modal backdrop
        popoutIconButton: {
            isVisible: false,
            onClick: null,
        }, // hidden by default
        size: 'normal', // 'normal' or 'window,
        title: '', // String
        zIndex: 9999, //
    };

    private closeIconButton: HTMLButtonElement;
    private popoutIconButton: HTMLButtonElement;
    private helpIconButton: HTMLButtonElement;

    public constructor(
        optionsParam: IAxModalOptions,
        componentTypeParam?: ComponentType
    ) {
        if (componentTypeParam) {
            this.componentType = componentTypeParam;
        }

        // Combine user provided options if present
        if (optionsParam && typeof optionsParam === 'object') {
            Object.assign(this.options, optionsParam);
        }

        if (!this.isBuilt && !this.options.lazyBuild) {
            AxModal.buildModal(this);
            AxModal.initialiseEvents(this);
        }
    }

    // Initialise events
    private static initialiseEvents(modalInstance: AxModal) {
        if (modalInstance.options.closeIconButton) {
            modalInstance.closeIconButton.addEventListener(
                'click',
                eventCallbackWrapper(
                    modalInstance.hide.bind(modalInstance),
                    modalInstance
                )
            );
        }

        if (modalInstance.popoutIconButton) {
            if (modalInstance.options.popoutIconButton?.onClick) {
                modalInstance.popoutIconButton.addEventListener(
                    'click',
                    eventCallbackWrapper(
                        modalInstance.options.popoutIconButton.onClick,
                        modalInstance
                    )
                );
            }
        }

        if (modalInstance.helpIconButton) {
            if (modalInstance.options.helpIconButton?.onClick) {
                modalInstance.helpIconButton.addEventListener(
                    'click',
                    eventCallbackWrapper(
                        modalInstance.options.helpIconButton.onClick,
                        modalInstance
                    )
                );
            }
        }

        if (
            modalInstance.options.clickOutsideToClose &&
            modalInstance.overlay
        ) {
            modalInstance.overlay.addEventListener(
                'click',
                eventCallbackWrapper(
                    modalInstance.hide.bind(modalInstance),
                    modalInstance
                )
            );
        } // TODO why do we have to bind these ones?

        window.addEventListener('keyup', function (event) {
            if (event.key === 'Escape') {
                event.stopPropagation();
                modalInstance.hide();
            }
        });
    }

    // Build modal private function
    private static buildModal(modalInstance: AxModal) {
        const componentType = modalInstance.componentType;
        const options = modalInstance.options;
        const dOptions = modalInstance.options as any;
        // Create a DocumentFragment to build with
        const docFrag = document.createDocumentFragment();

        // Create modal container
        const modal = document.createElement('div');
        modalInstance.modal = modal;

        // Set modal and variant classes
        modal.classList.add(`ax-${componentType}`);
        if (options.className) {
            modal.classList.add(options.className);
        }
        if (options.size) {
            modal.classList.add(`ax-${componentType}--${dOptions.size}`);
        }

        // dialogs options
        if (dOptions.titleIcon) {
            modal.classList.add(`ax-${componentType}--${dOptions.titleIcon}`);
        }
        if (dOptions.position) {
            modal.classList.add(`ax-${componentType}--${dOptions.position}`);
        }
        if (dOptions.headerBarStyle) {
            modal.classList.add(
                `ax-${componentType}--${dOptions.headerBarStyle}`
            );
        }

        modal.style.zIndex = options.zIndex.toString();

        // MODAL HEADER -----------------------------------------------------

        // Create header bar
        const modalHeader = document.createElement('div');
        modalHeader.className = `ax-${modalInstance.componentType}__header-container`;

        const modalHeaderText = document.createElement('p');
        modalHeaderText.className = `ax-${modalInstance.componentType}__header-text`;

        // Attach content
        if (typeof modalInstance.options.title === 'string') {
            modalHeaderText.innerHTML = modalInstance.options.title;
        } else {
            modalHeaderText.innerHTML = modalInstance.options.title.innerHTML;
        }

        // Add modal function button container
        const modalFuntionButtons = document.createElement('div');
        modalFuntionButtons.className = `ax-${modalInstance.componentType}__header-icons`;

        modalHeader.appendChild(modalHeaderText);
        modalHeader.appendChild(modalFuntionButtons);

        // Append header
        modalInstance.modal.appendChild(modalHeader);

        // Add modal function buttons (close, popout, help)
        if (modalInstance.options.popoutIconButton?.isVisible === true) {
            modalInstance.popoutIconButton = document.createElement('button');
            modalInstance.popoutIconButton.className = `ax-${modalInstance.componentType}__function-button`;
            modalInstance.popoutIconButton.innerHTML =
                // eslint-disable-next-line max-len
                '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.1846 1.22534L11.2899 8.13685" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.8816 1.22526L18.1849 1.22526L18.1849 6.52856" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.40234 18.1372L8.14397 11.3763" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.70536 18.1374L1.40206 18.1374L1.40206 12.8341" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            modalFuntionButtons.appendChild(modalInstance.popoutIconButton);
        }

        if (modalInstance.options.helpIconButton?.isVisible === true) {
            modalInstance.helpIconButton = document.createElement('button');
            modalInstance.helpIconButton.className = `ax-${modalInstance.componentType}__function-button`;
            modalInstance.helpIconButton.innerHTML =
                // eslint-disable-next-line max-len
                '<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.82366 17.7024C5.52229 17.7024 5.27832 17.9464 5.27832 18.2477C5.27832 18.5491 5.52229 18.7787 5.82366 18.7787C6.12504 18.7787 6.369 18.5348 6.369 18.2334C6.369 17.932 6.12504 17.7024 5.82366 17.7024Z" fill="#515B6D" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.51855 5.86291C1.51855 3.66719 3.16893 1.83025 5.33595 1.58628C7.51732 1.34231 9.52647 2.76307 10.0144 4.90139C10.5023 7.0397 9.3112 9.19237 7.259 9.92427C6.39793 10.2256 5.82389 11.0437 5.82389 11.9478V13.3972" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            modalFuntionButtons.appendChild(modalInstance.helpIconButton);
        }

        if (modalInstance.options.closeIconButton === true) {
            modalInstance.closeIconButton = document.createElement('button');
            modalInstance.closeIconButton.className = `ax-${modalInstance.componentType}__function-button`;
            modalInstance.closeIconButton.innerHTML =
                // eslint-disable-next-line max-len
                '<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.23242 16.6689L16.2324 1.66895" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.2324 16.6689L1.23242 1.66895" stroke="#515B6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            modalFuntionButtons.appendChild(modalInstance.closeIconButton);
        }

        // MODAL BODY --------------------------------------------------------
        // Create content area and append to modal
        const modalBody = document.createElement('div');
        modalBody.className = `ax-${modalInstance.componentType}__body`;

        // Attach content
        if (modalInstance.options.bodyContentType === 'iframe') {
            modalBody.className += ` ax-${modalInstance.componentType}__body--no-padding`;
            const ifrm = document.createElement('iframe');
            ifrm.classList.add(`ax-${modalInstance.componentType}__iframe`);
            ifrm.style.height =
                modalInstance.options.bodyContentIframe?.height || '';
            ifrm.setAttribute(
                'id',
                modalInstance.options.bodyContentIframe?.iframeId || ''
            );
            ifrm.setAttribute(
                'src',
                modalInstance.options.bodyContentIframe?.url || ''
            );
            modalBody.appendChild(ifrm);
        } else if (typeof modalInstance.options.bodyContent === 'string') {
            modalBody.innerHTML = modalInstance.options.bodyContent;
        } else {
            modalBody.innerHTML = modalInstance.options.bodyContent?.innerHTML;
        }

        modalInstance.modal.appendChild(modalBody);

        // MODAL FOOTER -------------------------------------------------------
        // Create footer/button bar
        const modalFooter = document.createElement('div');
        modalFooter.className = `ax-${modalInstance.componentType}__footer`;

        // Create and append footer buttons
        const modalFooterLeft = document.createElement('div');
        modalFooterLeft.className = `ax-${modalInstance.componentType}__footer-left`;
        const modalFooterRight = document.createElement('div');
        modalFooterRight.className = `ax-${modalInstance.componentType}__footer-right`;

        modalFooter.appendChild(modalFooterLeft);
        modalFooter.appendChild(modalFooterRight);

        modalInstance.options.footerButtons?.forEach((button) => {
            const generatedButton = document.createElement('button');
            generatedButton.innerHTML = button.text;
            generatedButton.className = `ax-btn ax-btn--${button.type}`;
            if (button.onClick) {
                generatedButton.addEventListener(
                    'click',
                    eventCallbackWrapper(
                        button.onClick.bind(modalInstance),
                        modalInstance
                    )
                );
            }

            if (button.position === 'left') {
                modalFooterLeft.appendChild(generatedButton);
            } else {
                modalFooterRight.appendChild(generatedButton);
            }
        });

        modalInstance.modal.appendChild(modalFooter);

        // Append modal to DocumentFragment
        docFrag.appendChild(modalInstance.modal);

        // If overlay is true, add one
        if (modalInstance.options.overlay === true) {
            modalInstance.overlay = document.createElement('div');
            modalInstance.overlay.className =
                `ax-overlay ` + modalInstance.options.className;
            modalInstance.overlay.style.zIndex =
                modalInstance.options.zIndex - 1;
            docFrag.appendChild(modalInstance.overlay);
        }

        // Append DocumentFragment to body
        document.body.appendChild(docFrag);
        modalInstance.isBuilt = true;
    }

    // Public methods
    public show() {
        if (!this.isBuilt && this.options.lazyBuild) {
            AxModal.buildModal(this);
        }
        this.modal.classList.add(`ax-${this.componentType}--open`);
    }

    public hide() {
        this.modal.classList.remove(`ax-${this.componentType}--open`);
    }

    public reflow() {
        // TODO
        // eslint-disable-next-line no-console
        console.log('reflow method');
    }

    public destroy() {
        this.modal.remove();
        this.overlay.remove();
        this.isBuilt = false;
    }
}

function eventCallbackWrapper(callback: ModalUIEvent, modalInstance: AxModal) {
    return (event: Event) => {
        let callbackResult = null;
        if (callback) {
            callbackResult = callback(event, modalInstance);
        }
        return callbackResult;
    };
}

// NOTE Extensibility, how can people extend it?
